module.exports = __webpack_public_path__ + "img/hovaLogo.26d1c635.svg";